// @ts-ignore
import("./bootstrap.js");
